/**
 * @typedef {object} CheckboxDefinition
 * @property {string} name - Уникальное имя чекбокса (используется как ключ состояния).
 * @property {string} title - HTML-строка заголовка чекбокса (может содержать ссылки).
 * @property {boolean} [initial=true] - Начальное состояние чекбокса (по умолчанию true).
 * @property {object} [tippy] - Опциональный объект с настройками для компонента TippyQuestion.
 * @property {string} tippy.text - Текст подсказки для TippyQuestion.
 * @property {boolean} [required=false] - Указывает, является ли чекбокс обязательным для валидации формы (по умолчанию false).
 */

/**
 * @type {CheckboxDefinition[]} ALL_CHECKBOX_DEFINITIONS - Массив определений для всех возможных чекбоксов в приложении.
 */

export const ALL_CHECKBOX_DEFINITIONS = [
  {
    name: 'rf',
    title: 'Подтверждаю, что являюсь гражданином РФ',
    initial: true,
    required: true
  },
  {
    name: 'privacy',
    title: `Согласен на обработку <a href='/privacy' target='_blank'>персональных данных</a>`,
    initial: true,
    tippy: {
      text: `Я подтверждаю свое ознакомление с Политикой Оператора в отношении обработки персональных данных
      и даю согласие на обработку моих персональных данных в соответствии с Федеральным законом от 27.07.2006
      года №152-ФЗ 'О персональных данных'`
    },
    required: true
  },
  {
    name: 'agreement',
    title: `Согласие на получение <a href='/agreement' target='_blank'>промо-рассылки</a>`,
    initial: true,
  },
];

/**
 * @type {string[]} ALL_CHECKBOX_NAMES - Массив имен всех возможных чекбоксов.
 */
export const ALL_CHECKBOX_NAMES = ALL_CHECKBOX_DEFINITIONS.map(def => def.name);
